import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-cookies-policy-template',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss']
})
export class CookiesPolicyTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
